import React, { memo } from 'react'
import iframely from 'lib/iframely'
import ZeusAd from 'components/ZeusAd'
import { useClientLayoutEffect } from 'hooks'

const articleAdPlaceholder = '<div id="Article-Ad-Placeholder" data-union-ad></div>'

function StoryHtml({ story, adSettings = false }) {
  // Load iframely for embeds
  useClientLayoutEffect(() => {
    iframely.load()
  }, [story.id])

  // Get story html
  const html = story.post_type_meta.standard_post.raw_content || ''

  // Ad that will be injected inplace of placeholder ad
  const createAd = (index) => {
    if (adSettings) {
      return (
        <div className='bs-articleAd'>
          <ZeusAd id={`In-Article-${index}`} adSettings={adSettings} />
        </div>
      )
    } else {
      return null
    }
  }

  // Split html based on article ad
  const fragments = html.split(articleAdPlaceholder)

  // Insert ad in between each fragment
  return fragments.map((__html, index) => (
    <React.Fragment key={index}>
      {!story.ads_disabled && story.type !== 'barstool_original' && index > 0 ? createAd(index) : null}
      <div dangerouslySetInnerHTML={{ __html }} />
    </React.Fragment>
  ))
}

export default memo(StoryHtml)
